import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getUserLanguage } from '../../utils/language';

const MiniHero = ({ title, videoPath }) => {
  const language = getUserLanguage();
  
  // Dynamické texty podle jazyka
  const texts = {
    cs: {
      backFull: 'Zpět na hlavní stránku',
      backShort: 'Zpět',
    },
    en: {
      backFull: 'Back to Homepage',
      backShort: 'Back',
    },
  };
  
  const currentText = texts[language] || texts.en; // Fallback na angličtinu
  
  return (
    <header className="mini-hero">
      <div className="mini-hero-video-container">
        <video autoPlay muted loop className="mini-hero-video"  preload="none">
          <source src={videoPath || '/images/videos/hero-background.mp4'} type="video/mp4" />
        </video>
      </div>
      <div className="hero-overlay"></div>
      <div className="hero-content-wrapper">
        <div className="hero-content flex flex-col items-center justify-center h-full relative">
          <h1
            className="hero-title text-2xl md:text-3xl mb-4"
            dangerouslySetInnerHTML={{ __html: title || '#NORISK<span>NODRIFT</span>' }}
          ></h1>
          <Link to="/" className="mini-hero-back-btn">
            <i className="fas fa-arrow-left mr-2"></i>
            {title ? currentText.backFull : currentText.backShort}
          </Link>
        </div>
      </div>
    </header>
  );
};

MiniHero.propTypes = {
  title: PropTypes.string,
  videoPath: PropTypes.string,
};

export default MiniHero;